<h1 mat-dialog-title>El formulario se envió correctamente</h1>
<div mat-dialog-content>Pronto nos estaremos contactando. Muchas Gracias!</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Aceptar</button>
</div>